<div class="page">
  <app-page-header  page-title="{{ pageTitle }}">
  </app-page-header>
  <div class="page-content">
    <mat-card class="custom-card mt-4">
      <div class="row">
        <div class="col-6">
          <mat-card-title>{{ 'ddts.checklistDetailPage.filesTab.title' | translate }}
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </div>
        <div class="col-6">

        </div>
      </div>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>
              <ng-container>
                <table class="table table-borderless table-striped" id="excel-table">
                  <thead>
                    <th>#</th>
                    <th>{{ 'ddts.checklistDetailPage.filesTab.property' | translate }}</th>
                    <th>{{ 'ddts.checklistDetailPage.filesTab.file' | translate }}</th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of fileData; let i = index">
                      <th style="width: 3%">{{ i + 1 }}</th>
                      <td style="width: 48%">{{ item.property }}</td>
                      <td style="width: 49%">{{ item.file }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </div> <!-- /.col -->
          </div> <!-- /.row -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
    <mat-card class="custom-card mt-4">
      <div class="row">
        <div class="col-6">
          <mat-card-title>{{ 'ddts.checklistDetailPage.modulesTab.title' | translate }}
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </div>
        <div class="col-6">

        </div>
      </div>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>
              <ng-container>
                <table class="table table-borderless table-striped" id="excel-table">
                  <thead>
                    <th>#</th>
                    <th>{{ 'ddts.checklistDetailPage.modulesTab.property' | translate }}</th>
                    <th>{{ 'ddts.checklistDetailPage.modulesTab.module' | translate }}</th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of moduleData; let i = index">
                      <th style="width: 3%">{{ i + 1 }}</th>
                      <td style="width: 48%">{{ item.property }}</td>
                      <td style="width: 49%">{{ item.module }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </div> <!-- /.col -->
          </div> <!-- /.row -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->